/* eslint-disable import/prefer-default-export */
import { graphql, useStaticQuery } from 'gatsby'

export const useBlogData = () => {
  const data = useStaticQuery(graphql`
    {
      allWpPost {
        nodes {
          date
          title
          uri
          slug
          seo {
            metaDesc
            title
            canonical
            opengraphTitle
            opengraphUrl
          }
          language {
            locale
            name
            slug
          }
          herocontent {
            herocontainerwidth
            herocontentheading
            heroseparatorusp2
            heroseparatorusp
            herodiscovermorelabel
            herocta2
            herocta1
            herocontenttext
            herocontentkicker
            herocontentimage {
              node {
                altText
                sourceUrl
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      quality: 80
                      webpOptions: { quality: 80 }
                      avifOptions: { lossless: true, quality: 80 }
                    )
                  }
                }
                mediaItemUrl
                mediaType
              }
            }
            herocontentmobileimage {
              node {
                altText
                sourceUrl
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      quality: 80
                      webpOptions: { quality: 80 }
                      avifOptions: { lossless: true, quality: 80 }
                    )
                  }
                }
                mediaItemUrl
                mediaType
              }
            }
          }
        }
      }
    }
  `)
  return data.allWpPost.nodes
}
